export enum ButtonDisplayMode {
    Edit = 'EDIT',
    View = 'VIEW',
    View_Edit = 'VIEW_EDIT'
}
